import { Component, Input, OnInit, inject, DestroyRef } from '@angular/core';
import { Solution } from 'src/app/models/service/solution';
import { MatDialog } from '@angular/material/dialog';
import { VideoDialogComponent } from 'src/app/components/video-dialog/video-dialog.component';
import { MediaCategory } from 'src/app/models/service/media-category';
import { Media } from 'src/app/models/service/media';
import { Capability, CapabilityType } from '../../../../models/service/capability';
import { ToastrService } from '../../../../services/util/toastr.service';
import { Permission, Permissions } from 'src/app/models/principal/permission';
import { AuthService } from 'src/app/services/auth/auth.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { UpgradePlanDialogComponent } from '../../upgrade-plan-dialog/upgrade-plan-dialog.component';
import { PermissionsService } from 'src/app/services/util/permissions.service';
import { RouterSegments } from 'src/app/models/router-segments';
import { ActivatedRoute, Router } from '@angular/router';
import { SolutionsService } from 'src/app/services/api/solutions.service';
import { DeploymentsService } from 'src/app/services/api/deployments.service';
import { DeployStatus } from 'src/app/models/deploy/deploy-status';
import { Instance } from 'src/app/models/instance/instance';
import { Deployment } from 'src/app/models/deploy/deployment';
import { translate } from '@jsverse/transloco';
import { ErrorDialogComponent } from 'src/app/components/error-dialog/error-dialog.component';
import { CreateSandboxDialogComponent } from '../../create-sandbox-dialog/create-sandbox-dialog.component';
import { BlueprintsService } from 'src/app/services/api/blueprints.service';
import { DeploymentClass } from '../../../../models/instance-class';
import { DataZone } from '../../../../models/data-zone/data-zone';
import { Blueprint } from 'src/app/models/blueprints/blueprint';
import { InstancesService } from 'src/app/services/api/instances.service';
import { SidenavService } from '../../../../services/util/sidenav.service';
import { ContactUsDialogComponent } from 'src/app/layout/toolbar/contact-us-dialog/contact-us-dialog.component';
import { PermissionKeys } from 'src/app/models/principal/permission-keys';

const UPDATED_REQUIRED_PERMISSIONS = [
  {
    key: PermissionKeys.BLUEPRINT_CREATE,
    action: Permissions.BLUEPRINT_CREATE
  }
];

const REQUIRED_PERMISSIONS = [
  Permission.UPGRADE_ENTERPRISE,
  Permission.DOWNLOAD_IAC,
];

@Component({
    selector: 'app-overview-view',
    templateUrl: './overview-view.component.html',
    styleUrls: ['./overview-view.component.scss'],
    standalone: false
})
export class OverviewViewComponent implements OnInit {

  @Input() service: Solution;
  @Input() capabilities: Capability[];
  @Input() selectedCapabilities: any[];
  @Input() displayStartFreeTrialButton: boolean;
  @Input() capabilityDescription: Capability[];
  @Input() solutionVersion: any;
  private destroyRef = inject(DestroyRef);

  PermissionKeys = PermissionKeys;
  marketingMedia: Media;
  capabilitiesGroups: CapabilitiesGroup[];
  hasMySandboxPermission: boolean;
  permissionsMap: { [key: string]: boolean };
  updatedPermissionsMap: { [key: string]: boolean };
  Permission = Permission;
  tenant: string;
  demoInstance: Instance;
  CapabilityType = CapabilityType;
  blueprintLatestVersion: any;
  blueprint: any;
  blueprintId: Blueprint;
  UpdateExtendService: boolean;
  UpdateExtendServiceDisable: boolean;
  selectedCapabilitiesLength = [];
  selectedCapabilitiesArr = [];
  sandboxLoader = false;
  disableCreateSandbox: boolean;
  instanceId: string;
  hasCreateSandboxPermission: boolean;
  descriptionArray: any;
  errorMessage: any;
  optionalAvailable: any;
  selectedMandatoryCapabilities: any;
  constructor(
    private matDialog: MatDialog,
    private authService: AuthService,
    private permissionService: PermissionsService,
    private toastrService: ToastrService,
    private router: Router,
    private solutionsService: SolutionsService,
    private deploymentsService: DeploymentsService,
    private blueprintsService: BlueprintsService,
    private activatedRoute: ActivatedRoute,
    private instancesService: InstancesService,
    private sidenavService: SidenavService,
    private permissionsService: PermissionsService
  ) {
  }

  ngOnInit(): void {
    this.loadInstances();
    this.blueprintId = this.activatedRoute.snapshot.params.blueprintId;
    const mediaList = this.service.media;
    const mediaURLs = mediaList.filter((item)=> {
      const pathname = new URL(item.mediaHref).origin;
      return pathname == 'https://player.vimeo.com';
    });

    this.marketingMedia = mediaURLs.find(media => media.category === MediaCategory.MARKETING);
    this.hasMySandboxPermission = !this.authService.hasPermission(Permission.VIEW_ENTERPRISE);
    this.permissionsMap = this.permissionService.resolveUserPermissions(REQUIRED_PERMISSIONS);
    this.hasCreateSandboxPermission = this.authService.hasPermission(Permission.CREATE_SANDBOX);
    this.updatedPermissionsMap = this.permissionsService.resolveAPIPermissions(UPDATED_REQUIRED_PERMISSIONS);
    this.selectedMandatoryCapabilities = [];
    if (this.capabilities?.length > 0) {
      const capabilitiesByType = this.capabilities
        .reduce((acc, capability) => {
          if (capability.required !== CapabilityType.OPTIONAL) {
            capability.selected = true;
            this.selectedMandatoryCapabilities.push(capability);
          } else if (capability.required === CapabilityType.OPTIONAL) {
            this.optionalAvailable = true;
          }

          let capabilitiesArr = acc[capability.required];
          if (capabilitiesArr == null) {
            capabilitiesArr = [];
            acc[capability.required] = capabilitiesArr;
          }
          capabilitiesArr.push(capability);
          return acc;
        }, {});
      let blueprintId;
      blueprintId = this.activatedRoute.snapshot.params.blueprintId;
      blueprintId = blueprintId ? this.loadBlueprint(blueprintId) : this.capabilitiesMapping(capabilitiesByType);
    }

  }
  capabilitiesMapping(capabilitiesByType?: any): void {
    this.capabilitiesGroups = Object.keys(capabilitiesByType)
      .map(capabilityType => ({ name: capabilityType, capabilities: capabilitiesByType[capabilityType] }));
  }

  loadBlueprint(blueprintId: string): void {
    if (blueprintId) {
      this.UpdateExtendService = true;
      this.blueprintsService.getBlueprintsIdLatestVersion(blueprintId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(blueprintLatestVersion => {
          this.blueprintLatestVersion = blueprintLatestVersion;
          this.blueprintLatestVersion = this.blueprintLatestVersion.capabilities;
          const capabilitiesByTypes = this.blueprintLatestVersion
            .reduce((bluePrintacc, bluePrintCapability) => {
              const capabilities = this.capabilities
                .reduce((acc, capability) => {
                  if (capability.required === CapabilityType.OPTIONAL && bluePrintCapability.name === capability.name) {
                    capability.selected = true;
                    capability.disabled = true;
                  }
                  let capabilitiesArr = acc[capability.required];
                  if (capabilitiesArr == null) {
                    capabilitiesArr = [];
                    acc[capability.required] = capabilitiesArr;
                  }
                  capabilitiesArr.push(capability);
                  return acc;
                }, {});
              bluePrintacc = capabilities;
              if (bluePrintCapability.required === CapabilityType.OPTIONAL) {
                this.selectedCapabilitiesLength.push(bluePrintCapability);
              }
              return bluePrintacc;
            }, {});
          this.capabilitiesMapping(capabilitiesByTypes);
          this.displayStartFreeTrialButton = true;
        }, (error) => {
          this.toastrService.clear();
              setTimeout(() => {
		  const title = translate('ERRORS.SERVICE_AVAILABILITY');
          const message = error?.message ? error?.message : (error?.error?.message ? error?.error?.message : (error?.errmsg ? error?.errmsg : translate('SERVICE.INTERNAL_SERVER_ERROR')));
          this.toastrService.errMessage(message, title);
        }, 500);
        });

      this.blueprintsService.getBlueprint(blueprintId)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(blueprint => {
          this.blueprint = blueprint.demo;
        });
    }
  }

  openVideo(): void {
    this.matDialog.open(VideoDialogComponent, {
      panelClass: 'default-dialog-wrapper',
      autoFocus: false,
      data: {
        videoHref: this.marketingMedia.mediaHref
      }
    });
  }
  downloadSetup(): void {
      // this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.service.id,
      //   RouterSegments.DOWNLOAD_IAC], { state: { data: this.getSelectedCapabilities() } });
  }

  setupService(): void {
    if(this.selectedMandatoryCapabilities.length === 0 && this.optionalAvailable && this.selectedCapabilitiesArr.length === 0) {
      this.toastrService.clear();
      this.toastrService.checkboxMessage('Please Select Capability to Create Service');
    } else {
      this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.service.id,
        RouterSegments.SERVICE_DEFINITION], { state: { data: this.getSelectedCapabilities(), solutionVersion: this.solutionVersion } });
    }
  }

  updateService(): void {
    this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.service.id,
      RouterSegments.SERVICE_DEFINITION, RouterSegments.EXTEND, this.activatedRoute.snapshot.params.blueprintId
    ], { state: { data: this.getSelectedCapabilities(), solutionVersion: this.solutionVersion } });
  }

  onOpenSandbox(): void {
    if(!this.displayStartFreeTrialButton) {
      if(this.selectedMandatoryCapabilities.length === 0 && this.optionalAvailable && this.selectedCapabilitiesArr.length === 0) {
        this.toastrService.clear();
        this.toastrService.checkboxMessage('Please Select Capability to Create Sandbox');
      } else if(this.solutionVersion?.sandboxType && this.solutionVersion?.sandboxType === 'enterprise') {
        this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.service.id,
            RouterSegments.SERVICE_DEFINITION], { state: { data: this.getSelectedCapabilities(), sandbox: true, solutionVersion: this.solutionVersion } });
      } else {
        this.matDialog.open(CreateSandboxDialogComponent, {
          panelClass: 'default-dialog-wrapper',
          width: '566px',
          autoFocus: false,
          data: {
            title: translate('SOLUTION_SUMMARY.CREATE_SANDBOX.CREATE_SANDBOX'),
            serviceName: this.service?.name,
            punchline: this.service?.punchline,
            confirmButtonText: translate('BUTTONS.CREATE_SANDBOX')
          }
        })
          .afterClosed()
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(confirm => {
            if (confirm) {
              this.sandboxLoader = true;
              this.onCreateSandbox();
            }
          }, (error) => {
            this.sandboxLoader = false;
          });
        }
    }

  }

  loadInstances(): void {
    this.instancesService.getInstancesForSolution(this.service.id)
      .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (instances: any) => {
        instances.filter((x) => {
          if (x.name === translate('BLUEPRINT_SUMMARY.DEMO_INSTANCE_SANDBOX') && x.blueprintId === this.blueprintId) {
            this.instanceId = x.id;
          }
        });
      });
  }

  onCreateSandbox(): void {
    let deployment;
    const getSelectedCapabilities = this.getSelectedCapabilities();
      const blueprint = {
        solutionId: this.service.id,
        name: 'Sandbox',
        demo: 'true'
      } as any;

    if (this.capabilities && this.capabilities.length > 0) {
      this.capabilities.filter((x) => {
        if (x.selected) {
          getSelectedCapabilities.push(x.name);
        }
      });
    }
    this.demoInstance = {
      status: DeployStatus.DEPLOYING
    } as Instance;

    this.blueprintsService.createBlueprint(blueprint).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (responseBlueprint) => {
        this.blueprintsService.createBlueprintVersion(responseBlueprint.id, getSelectedCapabilities)
          .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
          (blueprintVersion: any) => {
            this.router.navigate(['/', this.authService.principal.provider, RouterSegments.SERVICES, this.service.id,
              RouterSegments.BLUEPRINTS, responseBlueprint.id]);
            deployment = {
              blueprintId: responseBlueprint.id,
              blueprintVersionId: blueprintVersion.id,
              region: this.service.regionalAvailability[0],
              dataZone: DataZone.DEVELOPMENT,
              deploymentClass: DeploymentClass.D,
              name: translate('BLUEPRINT_SUMMARY.DEMO_INSTANCE_SANDBOX'),
              capabilities: getSelectedCapabilities,
              type: 'sandbox'
            } as Deployment;
            this.deploymentsService.createAndDeploy(deployment)
              .pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => { },
              (error) => {
                this.deployInstanceError(error);
                // Remove demoInstance if deployment fail to avoid disabling the button.
                delete this.demoInstance;
              });
          }, (error) => {
            this.deployInstanceError(error);
            // Remove demoInstance if deployment fail to avoid disabling the button.
            delete this.demoInstance;
          });
      }, (error) => {
        this.deployInstanceError(error);
        // Remove demoInstance if deployment fail to avoid disabling the button.
        delete this.demoInstance;
      });
  }

  deployInstanceError(error): void {
    this.sandboxLoader = false;
    this.matDialog.open(ErrorDialogComponent, {
      minHeight: '342px',
      width: '566px',
      panelClass: 'flex-dialog',
      data: {
        title: translate('NOTIFICATIONS.SANDBOX_FAILED'),
        description: error,
      }
    });
  }

  getSelectedCapabilities(): any[] {
    const selectedCapabilities = [];
    const selectedCapabilitiesByName = [];
    if (this.capabilities && this.capabilities.length > 0) {
      this.capabilities.filter((x) => {
        if (x.selected) {
          if (x?.nestedObj) {
            x.nestedObj.forEach(element => {
              element.selected = true;
            });
          }
          selectedCapabilities.push(x);
          selectedCapabilitiesByName.push(x.name);
        }
      });
    }
    localStorage.setItem('selectedCapabilities', JSON.stringify(selectedCapabilities));
    return selectedCapabilitiesByName;
  }


  openPlanModal(): void {
    this.matDialog.open(UpgradePlanDialogComponent, {
      maxHeight: '100vh',
      minHeight: '90vh',
      backdropClass: 'upgrade-plans-backdrop',
      maxWidth: '1400px',
      data: {
        displayStartFreeTrialButton: this.displayStartFreeTrialButton,
        disableCreateSandbox: this.disableCreateSandbox,
      }
    })
    .afterClosed()
    .pipe(takeUntilDestroyed(this.destroyRef))
    .subscribe(result => {
      if(result === translate('UPGRADE_PLAN.CREATE_TRIAL_SANDBOX')) {
        this.onOpenSandbox();
      }
      else if (result === translate('UPGRADE_PLAN.CONTACT_SALES')) {
        this.openContactForm();
      }
    });
  }

  openContactForm(): void {
    // this.sidenavService.openInRightSidenav(ContactUsDialogComponent);
    window.open('https://itsm-servicedesk.temenos.com/', '_blank');
  }

  selectedOptional(): any {
    const selectedCapabilities = [];
    if (this.capabilities && this.capabilities.length > 0) {
      this.capabilities.filter((x) => {
        if (x.selected === true && x.required === CapabilityType.OPTIONAL) {
          selectedCapabilities.push(x.name);
        }
      });
    }
    return selectedCapabilities;

  }

  selectionChanged(changedCapability: Capability): void {
    const selectedCapabilities = [];
    selectedCapabilities.push(changedCapability);
    this.toastrService.clear();
    this.toastrService.checkboxMessage(
      `${(changedCapability?.displayName)} ${changedCapability.selected ? 'Added' : 'Removed'}`
    );

    if (!this.activatedRoute.snapshot.params.blueprintId) {
      this.UpdateExtendService = false;
      this.UpdateExtendServiceDisable = false;
    } else {
      this.UpdateExtendService = true;
      this.UpdateExtendServiceDisable = true;

    }

    selectedCapabilities
      .reduce((acc, capability, c) => {
        if (capability.selected === true && capability.required === CapabilityType.OPTIONAL) {
          this.selectedCapabilitiesArr.push(capability);
        } else {
          this.selectedCapabilitiesArr
            .reduce((cap, falseCapability) => {
              if (falseCapability.selected === false) {
                const filtered = this.selectedCapabilitiesArr.filter((x) => {
                  if (x.selected === true && x.required === CapabilityType.OPTIONAL) {
                    return x.selected === true;
                  }
                });

                this.selectedCapabilitiesArr = filtered;
              }
              return cap;
            }, {});
        }
        return acc;
      }, {});

  }

  titleCaseWord(word): any {
    if (!word) { return word; }
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }

  isUpdated(capability): boolean {
    if (this.selectedCapabilities) {
      return this.selectedCapabilities.some(e => e.name === capability.name);
    }
  }
}

interface CapabilitiesGroup {
  capabilities: Capability[];
}
